import { GRAY, WHITE } from '@applyboard/ui-components';
import { chartColors } from "./colors";
export var defaultExportOptions = ['downloadCSV', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG'];
export var defaultChartOptions = {
  chart: {
    animation: false,
    backgroundColor: 'transparent',
    style: {
      fontFamily: 'Open Sans'
    }
  },
  credits: {
    enabled: false
  },
  exporting: {
    buttons: {
      contextButton: {
        height: 40,
        menuItems: defaultExportOptions,
        symbol: 'menuball',
        symbolStrokeWidth: 2,
        theme: {
          fill: "".concat(chartColors.GRAY[21])
        },
        width: 40
      }
    },
    chartOptions: {
      chart: {
        backgroundColor: "".concat(WHITE)
      }
    }
  },
  legend: {
    align: 'left',
    alignColumns: false,
    floating: false,
    borderRadius: 8,
    itemDistance: 40,
    itemStyle: {
      backgroundColor: "".concat(WHITE),
      color: "".concat(chartColors.GRAY[10]),
      fontSize: '14px',
      fontWeight: '500'
    },
    itemHoverStyle: {
      backgroundColor: "".concat(chartColors.BLUE[20])
    },
    itemMarginBottom: 10,
    symbolHeight: 8,
    symbolPadding: 12,
    symbolWidth: 8
  },
  plotOptions: {
    series: {
      marker: {
        enabled: false,
        height: 0,
        states: {
          hover: {
            enabled: true
          }
        },
        symbol: 'circle',
        width: 0
      }
    }
  },
  series: [],
  subtitle: {
    align: 'left',
    style: {
      color: "".concat(GRAY[10]),
      fontSize: '14px',
      fontWeight: '400'
    },
    text: undefined,
    y: 40
  },
  title: {
    align: 'left',
    style: {
      color: "".concat(GRAY[6]),
      fontSize: '20px',
      fontWeight: '600'
    },
    text: undefined
  },
  tooltip: {
    backgroundColor: "".concat(WHITE),
    borderRadius: 8,
    borderWidth: 0,
    shape: 'rect',
    useHTML: true
  },
  xAxis: {
    allowDecimals: false,
    gridLineColor: "".concat(chartColors.GRAY[18]),
    lineWidth: 1,
    minorGridLineColor: "".concat(chartColors.GRAY[18]),
    type: 'category'
  },
  yAxis: {
    gridLineColor: "".concat(chartColors.GRAY[18]),
    lineWidth: 1,
    title: {
      text: undefined
    }
  }
};